import React, { Component } from 'react'
import Helmet from 'react-helmet'

import Hero from '../components/ProgramOverview/Hero'
import Signup from '../components/Shared/Signup'
import Apply from '../components/Apply'
import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'
import ArchiveContent from '../components/ArchiveContent'
import { TransitionGroup, Transition } from 'react-transition-group'
import { TimelineMax } from 'gsap'
import Pagination from '../components/Pagination'


const PRESS_PER_PAGE = 6

export default class press extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pages:props.data.press.edges,
            currentPage:1,
            activePress:props.data.press.edges,
        }
    }

    componentDidMount() {
        this.params = {}
        if (window.location.search) {
            this.params = this.getUrlParams(window.location.search)
        }
        const totalPages = Math.ceil(this.state.pages.length / PRESS_PER_PAGE)
        const pageNumArray = []
        for (var i=1; i <= totalPages; i++) {
            pageNumArray.push(i)
        }

        this.setState({ pages:pageNumArray })


        this.row.refs.thisRow.style.position = 'relative'
    }

    handlePageChange(index) {
        // console.log('index == ', index)
        if (index > 0 && index <= this.state.pages.length) {
            this.params.page = index
            this.lastPage = this.state.currentPage
            this.setUrlParameters()
            let { pageNumberOffset } = this.state
            this.setState({ currentPage: index, pageNumberOffset })
        }
    }

    handleCardEnter(node) {
        const tl = new TimelineMax()
        tl.set(node, { css: { position:'absolute', top:0 }})
        if (this.lastPage && (this.lastPage < this.state.currentPage)) {
            // slide in left
            tl.fromTo(node, .15, { x:'100%' }, { x:'-=100%' }, .15)
            tl.set(node, { css: { position:'relative' }})
        }
        else {
            // slide in left
            tl.fromTo(node, .15, { x:'-100%' }, { x:'+=100%' }, .15)
            tl.set(node, { css: { position:'relative' }})
        }

    }

    handleCardExit(node) {
        if (this.lastPage && (this.lastPage < this.state.currentPage)) {
            TweenMax.fromTo(node, .15, { x:0 }, { x:'-=100%' })
        }
        else {
            TweenMax.fromTo(node, .15, { x:0 }, { x:'+=100%' })
        }
    }

    getUrlParams(search) {
        let hashes = search.slice(search.indexOf('?') + 1).split('&')
        return hashes.reduce( (params, hash) => {
            let [key, val] = hash.split('=')
            return Object.assign(params, {[key]: decodeURIComponent(val)})
        }, {} )
    }

    setUrlParameters() {
        var queryString = Object.keys(this.params).map(key => key + '=' + this.params[key]).join('&')
        var newurl = window.location.pathname + '?' + queryString
        window.history.replaceState( { path:newurl }, '', newurl);
    }

    getPressByPage() {
        let { currentPage, activePress } = this.state
        const startIndex = (currentPage - 1) * PRESS_PER_PAGE
        return activePress.slice(startIndex, startIndex + PRESS_PER_PAGE)
    }

    render() {
        const { data: { press }} = this.props
        const { currentPage, pages } = this.state
        const pagedPress = this.getPressByPage()

        return (
            <div className="page-archive">
                <Helmet title='News & Press | Global Citizen Year' />
                <Hero title="News & Press" />

                <Row className="capper" style={{ paddingBottom:'30px' }}>
                    { pages.length > 1 &&
                        <Pagination pages={ pages } currentPage={ currentPage } handlePageChange={ page => this.handlePageChange(page) }/>
                    }
                </Row>
                <Row className="cards-container capper no-top-padding no-bottom-padding">
                    <TransitionGroup>
                        <Transition key={ this.state.currentPage }
                            timeout={ 300 }
                            onEnter={ node => this.handleCardEnter(node) }
                            onExit={ node => this.handleCardExit(node) }>
                            <Row ref={ el => this.row = el } className="no-padding">
                                { pagedPress.map( (post, index) => (
                                    <div className="author-post" key={ index }>
                                        <ArchiveContent data={ post.node } archiveType="press" />
                                    </div>
                                ))}
                            </Row>
                        </Transition>
                    </TransitionGroup>
                </Row>
                <Row className="capper" style={{ paddingBottom:'80px', paddingTop: '0px' }}>
                    { pages.length > 1 &&
                        <Pagination pages={ pages } currentPage={ currentPage } handlePageChange={ page => this.handlePageChange(page) }/>
                    }
                </Row>

                <Apply
                  title={'Curious about Global Citizen Year? This is a great place to start.'}
                  buttonUrl={ `/academy/apply/` }
                />
            </div>
        )
    }
}


export const pressQuery = graphql`
  query PressQuery {
    press: allWordpressWpPress {
        edges {
          node {
            slug
            title
            date(formatString: "DD MMMM, YYYY")
            content
            excerpt
            featured_media
          }
        }
    }
}
`



// WEBPACK FOOTER //
// ./src/pages/press.js